import React, {useContext, useState, useEffect} from 'react'
import t from './../../helpers/I18n'
import logo from '../../assets/png/hellobank.png'
import BaseButton from "../base-components/base-button";
import DialogBox from "../base-components/dialog-box";
import PropTypes from "prop-types";
import { useLocation } from 'react-router-dom'
import {BreakPointContext} from "../../contexts/breaking-point";
import { useHistory } from "react-router-dom";
import deleteCookie from '../../functions/deleteCookie';



const Header = ({title}) => {
    const history = useHistory();
    const [showDialogBox, setShowDialogBox] = useState(false)
    const [showClose, setShowClose] = useState(true)
    const breakpoint = useContext(BreakPointContext)
    const location = useLocation();
    const lang = localStorage.getItem('language')
    
    useEffect(() => {
        ( location.pathname.includes('pre-confirmation') ||
        location.pathname.includes('confirmation')
       ) && setShowClose(false)
    }, [showClose])

    const content = {
        message: t('general.quit_message'),
        confirm: t('general.yes'),
        cancel: t('general.no'),
        confirmAction: ()=>{
            setShowDialogBox(false)
            // history.push('/')
            // deleteCookie(() => window.location.href = lang === "FR" ? "https://pro.qahellobank.be/fr/public/accueil" : "https://pro.qahellobank.be/nl/public/startpagina")
            
                if (process.env.REACT_APP_ENV === "qa") {
                deleteCookie( () => window.location.href = lang === "FR" ? "https://pro.qahellobank.be/fr/public/accueil" : "https://pro.qahellobank.be/nl/public/startpagina")
                } else if (process.env.REACT_APP_ENV === "prod") {
                deleteCookie( () => window.location.href = lang === "FR" ? "https://pro.hellobank.be/fr/public/accueil" : "https://pro.hellobank.be/nl/public/startpagina")
                } else {
                deleteCookie( () => window.location.href = lang === "FR" ? "https://pro.qahellobank.be/fr/public/accueil" : "https://pro.qahellobank.be/nl/public/startpagina")
                }

        },
        cancelAction: ()=>{
            setShowDialogBox(false)
        }
    }
    return(
        <>
                <header className={"header"}>
                        <div className={"logo"}><img src={logo} alt=""/></div>
                            {(breakpoint.isDesktop || breakpoint.isTablet) && <div className={"header__title"}>{title}</div>}
                {showClose && 
                      <BaseButton
                            className={"header__button"}
                            icon={breakpoint.isDesktop || breakpoint.isTablet ? "cross" : false}
                            light
                            caption={t('close')}
                            action={()=>{setShowDialogBox(true)}}
                        />
                      }  
                </header>
                { showDialogBox &&  <DialogBox content={content}  /> }
        </>
    )
}


Header.propTypes = {
    title: PropTypes.string,
    loaded: PropTypes.number,
}

export default Header
